import produce from 'immer'
import {
  hideDeviceInfoOverlay,
  hideGenericTicketDetailsOverlay,
  showDeviceInfoOverlay,
  showGenericTicketDetailsOverlay,
} from 'shared/store/actions/sidebar/overlay'

import { createReducer } from 'typesafe-actions'

export interface OverlayConfig {
  show: boolean
  id: string
}

export const overlay = createReducer<Record<string, OverlayConfig>>({
  genericTicketDetails: {
    show: false,
    id: '',
  },
  deviceInfo: {
    show: false,
    id: '',
  },
})
  .handleAction(showGenericTicketDetailsOverlay, (state, action) =>
    produce(state, (draft) => {
      draft.genericTicketDetails.show = true
      draft.genericTicketDetails.id = action.payload
    })
  )
  .handleAction(hideGenericTicketDetailsOverlay, (state) =>
    produce(state, (draft) => {
      draft.genericTicketDetails.show = false
      draft.genericTicketDetails.id = ''
    })
  )
  .handleAction(showDeviceInfoOverlay, (state, action) =>
    produce(state, (draft) => {
      draft.deviceInfo.show = true
      draft.deviceInfo.id = action
    })
  )
  .handleAction(hideDeviceInfoOverlay, (state) =>
    produce(state, (draft) => {
      draft.deviceInfo.show = false
      draft.deviceInfo.id = ''
    })
  )
